module.exports = __webpack_public_path__ + "static/img/banner-en-1.6785cd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-en-1.jpg
// module id = rSSR
// module chunks = 1